import axios from 'axios'
import React, { useState, useRef } from 'react'
import { Form } from 'react-bootstrap'
import { toast } from 'react-toastify'
import SimpleReactValidator from 'simple-react-validator'
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle'
import { fetchCsrfCookie } from '../../../redux/action/csrf/csrf-cookie'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {IoCloseCircleOutline} from 'react-icons/io5'
import './style.scss'

const CreateUser = (props) => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    const [confirmLogo, setConfirmLogo] = useState(false)
    const [typingTimeout, setTypingTimeout] = useState(0)
    let dispatch = useDispatch()
    const {t} = useTranslation();

    const [data, setData] = useState({
        manager_name: "",
        manager_mobile: "",
        username: "",
        password: "",
        confirm_password: "",
    })

    const changeHandler = event => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const confirmPasswordHandler = event => {
        setData({ ...data, [event.target.name]: event.target.value })
        if (typingTimeout) { 
            clearTimeout(typingTimeout) 
        }
        setTypingTimeout(setTimeout(function () {
            if(data.password !== event.target.value ) {
                setConfirmLogo(true)
            } else {
                setConfirmLogo(false)
            }
        }, 1000))
    }

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است",
          min: " تعداد کاراکترهای ورودی کم است " 
        },
    }))

    const handleFromSubmit = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            setBtnLoading(false)
            if (data.password !== data.confirm_password) {
                toast.dismiss()
                toast.error(t("toast_repeat_password_does_not_match") , {position: 'bottom-right',className: 'foo-bar'})
            } else {
                dispatch(fetchCsrfCookie())
                axios.post('developer/admin-profile', data, {withCredentials: true})
                .then(res => {
                    toast.dismiss()
                    toast.success(t("toast_successfully_created") , {position: 'bottom-right',className: 'foo-bar'})
                    props.update()
                    window.scrollTo(0, 0)
                    setData({
                        manager_name: "",
                        manager_mobile: "",
                        username: "",
                        password: "",
                        confirm_password: "",
                    })
                })
                .catch(err => {
                    if(err.response) {
                        if(err.response.status) {
                            if(err.response.status === 422){
                                toast.dismiss()
                                toast.error(t("toast user already exist") , {position: 'bottom-right',className: 'foo-bar'})
                                setData({
                                    manager_name: "",
                                    manager_mobile: "",
                                    username: "",
                                    password: "",
                                    confirm_password: "",
                                })
                            } else {
                                toast.error(t("toast_something_went_wrong") , {position: 'bottom-right',className: 'foo-bar'})
                            }
                        }
                    }
                })
            }
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    return (
        <div>
            <DashboardMainTitle> {t("create new user")} </DashboardMainTitle>
            <Form className='col-lg-6'>
                <Form.Group className="mb-3" controlId="formBasicText">
                    <Form.Label>{t("user name")} :</Form.Label>
                    <Form.Control type="text" name="manager_name" value={data.manager_name} onChange={changeHandler} />
                    <span className='validator_error'>{validator.current.message('manager_name', data.manager_name, 'required')}</span>
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicText">
                    <Form.Label>{t("user phone number")} :</Form.Label>
                    <Form.Control type="text" name="manager_mobile" value={data.manager_mobile} onChange={changeHandler} />
                    <span className='validator_error'>{validator.current.message('manager_mobile', data.manager_mobile, 'required|min:11')}</span>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicText">
                    <Form.Label>{t("username")} :</Form.Label>
                    <Form.Control type="text" name="username" value={data.username} onChange={changeHandler} />
                    <span className='validator_error'>{validator.current.message('username', data.username, 'required')}</span>
                </Form.Group>
                
                <Form.Group className="mb-3" controlId="formBasicText">
                    <Form.Label>{t("password")} :</Form.Label>
                    <Form.Control  type="password" name="password" value={data.password} onChange={confirmPasswordHandler} />
                    <span className='validator_error'>{validator.current.message('password', data.password, 'required|min:8')}</span>
                </Form.Group>
                <Form.Group className="mb-3 confirm_wrapper" controlId="formBasicText">
                    <Form.Label>{t("repeat password")} :</Form.Label>
                    <Form.Control  type="password" name="confirm_password" value={data.confirm_password} onChange={confirmPasswordHandler} />
                    <span className='validator_error'>{validator.current.message('confirm_password', data.confirm_password, 'required|min:8')}</span>
                    {confirmLogo ? <IoCloseCircleOutline title='تکرار رمز عبور مطابقت ندارد' className='pass_validator' /> : "" }
                </Form.Group>
                <button className="btn green-btn" type="button" onClick={handleFromSubmit} disabled={btnLoading ? true : false}>{t("submit")}</button>
            </Form>
        </div>
    )
}

export default CreateUser
